import { Trans, useTranslation } from 'react-i18next';

import {
  ArrowCircleRight,
  Button,
  Prohibit,
  Typography,
} from '@gbm/starman-next';
import { translations } from '@gbm/onboarding-sdk-utils';
import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@gbm/onboarding-sdk-ui-components';

import styles from './initial-screen.module.scss';

export type RejectedDocumentsProps = Readonly<{
  onClose: () => void;
}>;
const {
  buttons,
  upgrade: { contractStatus },
} = translations;

export default function RejectedDocuments({ onClose }: RejectedDocumentsProps) {
  const { t } = useTranslation();

  return (
    <Modal show>
      <ModalHeader onClose={onClose} />
      <ModalContent>
        <div className={styles['rejected-documents-icon']}>
          <Prohibit
            size={styles['icon-size']}
            color={styles['icon-color--error']}
          />
        </div>
        <div className={styles['rejected-documents-title']}>
          <Typography variant="h5">
            {t(contractStatus.rejectedDocumentsTitle)}
          </Typography>
        </div>
        <div className={styles['rejected-documents-description']}>
          <Typography variant="small">
            <Trans
              i18nKey={contractStatus.rejectedDocumentsDescription}
              components={[
                <span className={styles['rejected-documents-link']}></span>,
                <br></br>,
              ]}
            />
          </Typography>
        </div>
      </ModalContent>
      <ModalFooter>
        <Button
          size="fluid"
          kind="primary"
          onClick={onClose}
          icon={<ArrowCircleRight size={styles['icon-size']} weight="fill" />}
        >
          {t(buttons.understood)}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
